import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { User } from "../../interfaces/users/user-list-response.interface";
import { IAuthState, IUser, IUserInfo, Tenant } from "../../interfaces/vendors/auth.interface";




const initialState: IAuthState = {
    isAuth: 0,
    currentUser: {
        permissions: []
    } as IUser
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuth: (state, action: PayloadAction<number>) => {
            state.isAuth = action.payload
        },
        setUser: (
            state,
            action: PayloadAction<User> 
        ) => {
            state.currentUser = { ...state.currentUser, ...action.payload }
        },
        setUserInformation: (
            state,
            action: PayloadAction<IUserInfo>
        ) => {
            state.currentUser.firstname = action.payload.firstname
            state.currentUser.lastname = action.payload.lastname
        },

        setUserTenant: (state, action: PayloadAction<Tenant[]>) => {
            //TODO set user tenant
            // state.currentUser.tenants = action.payload
        },
        setUserPermissions: (state, action: PayloadAction<string[]>) => {
            //TODO set user permissions
            state.currentUser.permissions = action.payload
        }

    }
});

export const { setAuth, setUser, setUserTenant, setUserPermissions, setUserInformation } = authSlice.actions;
export default authSlice.reducer;